var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.receiptQr)?_c('app-spinner'):_vm._e(),_vm._v(" "),(_vm.receiptQr)?_c('img',{staticClass:"app-receipt-qr__img",attrs:{"src":_vm.receiptQr,"alt":"receipt-qr"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }